<template>
  <h2 class="mb-3 text-left">{{ typeName }}</h2>
  <dl class="c-radio mb-3 pb-3 border-bottom">
    <dt class="pl-1">
      <input
        v-model="addressNo"
        type="radio"
        name="optShippingAddress"
        :id="sequentialNo"
        :value="sequentialNo"
        v-on:change="selectAddress"
      />
      <label :for="sequentialNo" class="name">{{ destName }}</label>
    </dt>
    <dd class="w-100 pl-2 d-flex column_sp justify-content-between">
      住所：〒{{ zipCode }}&emsp;{{ address1 + address2 }}<br />
      電話：{{ tel }}<br />
      お届け予定日：{{ shortestDate }}
      <div class="delete text-center mt-4 mr-4" v-show="type > 0">
        <button @click="deleteAddress">削除</button>
      </div>
    </dd>
  </dl>
</template>

<script>
import Request from "@/modules/Request";
import Message from "@/modules/Message";
let request = new Request();

export default {
  props: [
    "type",
    "typeName",
    "sequentialNo",
    "destName",
    "zipCode",
    "address1",
    "address2",
    "tel",
    "shortestDate",
    "deliveryAddressNo",
  ],
  emits: ["updateAddress", "selectAddress"],
  data() {
    return {
      addressNo: this.deliveryAddressNo,
    };
  },
  methods: {
    selectAddress() {
      this.$emit("selectAddress", this.addressNo);
    },
    deleteAddress() {
      Message.confirm()
      .fire({
        title: "削除します。宜しいですか？",
      }).then((result) => {
          if (result.isConfirmed) {
            let postParams = [this.sequentialNo];
            let requestParams = request.createParams(
              "webMdlShippingAddress",
              "delAddress",
              postParams
            );
            request
              .create()
              .post("", requestParams)
              .then(() => {
                Message.success().fire({
                  title: "住所を削除しました"
                });

                this.$emit("updateAddress");
              });
          }
      });
    },
  },
};
</script>